/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatClientPersona
 */
export interface ChatClientPersona {
    /**
     * Unique identifier of the client persona
     * @type {string}
     * @memberof ChatClientPersona
     */
    id: string;
    /**
     * Display name of the chat client
     * @type {string}
     * @memberof ChatClientPersona
     */
    name: string;
    /**
     * Email address of the chat client
     * @type {string}
     * @memberof ChatClientPersona
     */
    email: string;
    /**
     * IP address of the chat client
     * @type {string}
     * @memberof ChatClientPersona
     */
    ip: string;
    /**
     * URL the client was on when they started the chat
     * @type {string}
     * @memberof ChatClientPersona
     */
    url: string;
    /**
     * Timestamp when the client accepted the legal notice
     * @type {Date}
     * @memberof ChatClientPersona
     */
    legalNoticeAccepted: Date;
    /**
     * The type discriminator for this persona
     * @type {string}
     * @memberof ChatClientPersona
     */
    type: ChatClientPersonaTypeEnum;
}


/**
 * @export
 */
export const ChatClientPersonaTypeEnum = {
    ChatClientPersona: 'ChatClientPersona',
    ChatAgentPersona: 'ChatAgentPersona',
    WorkspacePersona: 'WorkspacePersona',
    ChatWorkspaceDomainPersona: 'ChatWorkspaceDomainPersona'
} as const;
export type ChatClientPersonaTypeEnum = typeof ChatClientPersonaTypeEnum[keyof typeof ChatClientPersonaTypeEnum];


/**
 * Check if a given object implements the ChatClientPersona interface.
 */
export function instanceOfChatClientPersona(value: object): value is ChatClientPersona {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('ip' in value) || value['ip'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('legalNoticeAccepted' in value) || value['legalNoticeAccepted'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ChatClientPersonaFromJSON(json: any): ChatClientPersona {
    return ChatClientPersonaFromJSONTyped(json, false);
}

export function ChatClientPersonaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatClientPersona {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'ip': json['ip'],
        'url': json['url'],
        'legalNoticeAccepted': (new Date(json['legalNoticeAccepted'])),
        'type': json['type'],
    };
}

export function ChatClientPersonaToJSON(json: any): ChatClientPersona {
    return ChatClientPersonaToJSONTyped(json, false);
}

export function ChatClientPersonaToJSONTyped(value?: ChatClientPersona | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'ip': value['ip'],
        'url': value['url'],
        'legalNoticeAccepted': value['legalNoticeAccepted'].toISOString(),
        'type': value['type'],
    };
}

